<template>
  <div id="charts-container">
    <v-row no-gutters>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="8"
        xl="9"
        :style="$vuetify.breakpoint.xlOnly ? 'margin-left: -40px' : ''"
      >
        <div class="d-flex">
          <div class="pt-1 pr-2">
            <v-btn icon @click="backToPreviousScreen">
              <v-icon size="34" color="accent"
                >icon-alertadis-angle-left-b</v-icon
              >
            </v-btn>
          </div>
          <div>
            <div class="historical-data-title">
              <span>Dados históricos</span>
            </div>
            <div>
              <span class="historical-data-sub-title"
                >Consulte os dados de eventos passados.</span
              >
            </div>
          </div>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="4"
        xl="3"
        class="d-flex"
        style="height: 40px"
      >
        <div
          class="py-2 pr-2 pl-1 graph-table-chip d-flex"
          style="max-width: 725px"
        >
          <v-btn
            height="24"
            class="daily-btn daily-btn-active"
            @click="toggleNavigation"
          >
            <span class="daily-btn-text" v-if="typeLocation == 'regional'">
              REGIONAL
              {{ filterSelected.location.fullname.toUpperCase() }}</span
            >

            <span class="daily-btn-text" v-if="typeLocation == 'agency'">
              Base de Serviço de Campo
              {{ filterSelected.location.name.toUpperCase() }}</span
            >
            >
            <span class="daily-btn-text" v-if="typeLocation == 'countie'">
              MUNICÍPIO
              {{ filterSelected.location.name.toUpperCase() }}</span
            >
          </v-btn>

          <v-btn
            height="24"
            class="daily-btn daily-btn-active"
            @click="toggleNavigation"
          >
            <span class="daily-btn-text" v-if="daily == true">
              {{ dailyPeriods.dates[dailyPeriods.dates.length - 1].name }}</span
            >

            <span class="daily-btn-text" v-if="daily == false">
              {{
                moment(hourlyPeriods[hourlyPeriods.length - 1].date).format(
                  'ddd. DD/MM/YYYY HH:mm',
                )
              }}</span
            >
          </v-btn>

          <v-btn height="24" @click="toggleNavigation" dense color="#151723">
            <v-icon> icon-alertadis-tune </v-icon>
            <span class="daily-btn-text btn-filter">Filtrar</span>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row class="pt-2">
      <v-col cols="12" sm="12" md="12" lg="5">
        <div class="ci-forecast-title">Previsão de Consumidor Interrompido</div>
        <div class="ci-forecast-sub-title">
          Verifique o que foi previsto para o dia ou a hora selecionada.
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="7"
        class="d-flex flex-column align-end"
      >
        <div class="py-2 forecast-time-text">
          {{ daily ? forecastDate : forecastTime }}
        </div>
        <div v-if="daily" class="d-flex flex-wrap graph-table-chip">
          <div>
            <v-btn
              height="24"
              v-for="(daily, i) in dailyPeriods.dates"
              :key="i"
              :class="
                isSelectedDaily(daily)
                  ? 'daily-btn daily-btn-active'
                  : 'daily-btn'
              "
              @click="toggleItemDaily(daily)"
            >
              <span class="daily-btn-text">{{ daily.name }}</span>
            </v-btn>
          </div>
          <span class="px-2"></span>
          <div class="d-flex">
            <v-btn
              v-show="false"
              height="24"
              width="40"
              v-for="(btn, i) in dailyPeriods.hours"
              :key="i"
              :class="
                isSelectedhourlyInDailyPeriods(btn)
                  ? 'hourly-in-daily-btn hourly-in-daily-btn-active'
                  : 'hourly-in-daily-btn'
              "
              @click="togglehourlyInDailyPeriods(btn)"
            >
              <span class="hourly-in-daily-btn-text">{{ btn.text }}</span>
            </v-btn>
          </div>
        </div>
        <div v-else>
          <div class="d-flex flex-wrap justify-end graph-table-chip">
            <v-btn
              height="24"
              v-for="(hour, i) in hourlyPeriods"
              :key="i"
              :class="
                isSelectedHour(hour)
                  ? 'daily-btn daily-btn-active'
                  : 'daily-btn'
              "
              @click="toggleItemHour(hour)"
            >
              <span class="daily-btn-text">{{ hour.name }}</span>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="8" xl="8">
        <div v-show="typeLocation == 'regional'" id="ciChartRegional"></div>
        <div v-show="typeLocation == 'agency'" id="ciChartAgency"></div>
        <div v-show="typeLocation == 'countie'" id="ciChartCountie"></div>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <div
          v-show="typeLocation == 'agency' || typeLocation == 'countie'"
          id="ciChartFull"
        ></div>
        <div v-show="typeLocation == 'regional'" id="ciChartFullRegional"></div>
      </v-col>
    </v-row>
    <v-row class="pt-4">
      <v-col cols="12">
        <div class="ci-forecast-title">Dados previstos e dados registrados</div>
        <div class="ci-forecast-sub-title">
          Compare as previsões do modelo meteorológico com os registros nas
          estações.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <div id="windChart"></div>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <div id="preciChart"></div>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <div v-show="daily" id="tempChart"></div>
        <div v-show="!daily" id="tempMedChart"></div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <div id="lightningChart"></div>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="8" xl="8">
        <div v-show="typeLocation == 'regional'" id="weatherAlertChart"></div>
        <div
          v-show="typeLocation != 'regional'"
          style="
            width: 100%;
            height: 100%;
            background-color: #151723;
            border-radius: 16px;
          "
        >
          <div class="pa-2" style="height: 10%">
            <v-icon size="18">icon-alertadis-thunderstorm-sun</v-icon>
            <span class="pl-1 weather-alert-title">Alertas Meteorológicos</span>
          </div>
          <div class="d-flex justify-center align-center" style="height: 90%">
            <div class="my-2 info-alert" style="width: 80%">
              <div class="d-flex">
                <div class="d-flex align-center">
                  <v-icon color="primary darken-3"
                    >icon-alertadis-info-circle</v-icon
                  >
                </div>
                <div>
                  <div class="pl-2 info-alert-text d-flex align-center">
                    Para visualizar os alertas meteorológicos selecione uma
                    regional
                  </div>
                  <div class="pl-2 info-alert-text d-flex align-center">
                    Os alertas meteorológicos são emitidos por regional, então
                    não é possível visualizá-los no filtro por agência ou
                    município.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment-timezone';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import offlineExporting from 'highcharts/modules/offline-exporting';
import accessibility from 'highcharts/modules/accessibility';
exportingInit(Highcharts);
offlineExporting(Highcharts);
accessibility(Highcharts);

require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/bullet')(Highcharts);
require('highcharts/modules/pattern-fill')(Highcharts);

import {mapGetters} from 'vuex';

export default {
  props: {
    daily: {
      type: Boolean,
      required: true,
    },
    dailyPeriods: {
      type: Object,
      required: true,
    },
    hourlyPeriods: {
      type: Array,
      required: true,
    },
    typeLocation: {
      type: String,
      required: true,
    },
    filterSelected: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    selectedDaily: [],
    selectedHour: [],
    hourlyInDailyPeriodsSelected: {id: 0, name: '00:00'},
    ciChartFull: null,
    ciChartRegional: null,
    ciChartAgency: null,
    ciChartCountie: null,
    fakeLegendAgencyChart: null,
    fakeLegendCountieChart: null,
    fakeLegendWeatherAlertChart: null,
    fakeLegendPreciChartChart: null,
    windChart: null,
    preciChart: null,
    tempChart: null,
    lightningChart: null,
    weatherAlertChart: null,
    textSubtitle: null,
    textTitleTooltip: null,
    tempMedChart: null,
  }),
  watch: {
    typeLocation: {
      deep: true,
      handler(value) {
        if (value) {
          this.resizeCharts();
        }
      },
    },
    filterSelected: {
      deep: true,
      handler(value) {
        if (value) {
          this.selectedDaily = [...this.dailyPeriods.dates];
          this.selectedHour = [...this.hourlyPeriods];
        }
      },
    },
    historicalCountieData: {
      deep: true,
      handler(value) {
        if (value) {
          this.createCiChartCountie();
          this.resizeCharts();
        }
      },
    },

    historicalRegionalData: {
      deep: true,
      handler(value) {
        if (value) {
          this.createCiChartRegional();
          this.resizeCharts();
        }
      },
    },

    historicalAgencyData: {
      deep: true,
      handler(value) {
        if (value) {
          this.createCiChartAgency();
          this.resizeCharts();
        }
      },
    },

    historicalFullData: {
      deep: true,
      handler(value) {
        if (value) {
          this.createCiChartFull();
          this.resizeCharts();
        }
      },
    },

    historicalFullRegional: {
      deep: true,
      handler(value) {
        if (value) {
          this.createCiChartFullRegional();
          this.resizeCharts();
        }
      },
    },

    historicalForecastsData: {
      deep: true,
      handler(value) {
        if (value) {
          this.createWindChart();
          this.createPreciChart();
          this.createTempChart();
          this.createTempMedChart();
          this.resizeCharts();
          this.rerenderFakeLegend();
        }
      },
    },
    weatherData: {
      handler(value) {
        if (value) {
          this.createWeatherAlertChart(value);
          this.rerenderFakeLegend();
          this.resizeCharts();
        }
      },
    },
    recordedDataFromTelmetryStations: {
      handler(value) {
        if (value) {
          this.createWindChart();
          this.createPreciChart();
          this.createTempChart();
          this.resizeCharts();
          this.rerenderFakeLegend();
        }
      },
    },

    lightningCountData: {
      deep: true,
      handler(value) {
        if (value) {
          this.createLightningChart(this.lightningCountData);
        }
      },
    },
  },
  created() {
    this.selectedDaily = [...this.dailyPeriods.dates];
    this.selectedHour = [...this.hourlyPeriods];
  },
  mounted() {
    this.createCiChartFull();
    this.createCiChartFullRegional();
    this.createCiChartRegional();
    this.createCiChartAgency();
    this.createCiChartCountie();
    this.createWindChart();
    this.createPreciChart();
    this.createTempChart();
    this.createTempMedChart();
    this.createLightningChart(this.lightningCountData);
    this.createWeatherAlertChart([...this.weatherData]);
    this.resizeCharts();
  },
  computed: {
    ...mapGetters([
      'historicalCountieData',
      'weatherData',
      'recordedDataFromTelmetryStations',
      'lightningCountData',
      'historicalRegionalData',
      'historicalAgencyQtdeUc',
      'historicalAgencyData',
      'historicalFullData',
      'historicalFullRegional',
      'historicalRegionalQtdeUc',
      'historicalForecastsData',
    ]),
    forecastDate() {
      const date = this.dailyPeriods.dates[4].name;
      return `Previsão para ${moment(date, 'DD/MM/YYYY').format(
        'dddd, DD [de] MMMM [de] YYYY',
      )}`;
    },
    forecastTime() {
      const [date, time] = this.hourlyPeriods[2].name.split(' ');
      return `Hora da previsão para ${moment(date, 'DD/MM/YYYY').format(
        'dddd, DD [de] MMMM [de] YYYY',
      )} das ${time} às ${moment(date, 'DD/MM/YYYY')
        .hour(parseInt(time.split(':')[0]) + 1)
        .format('HH:mm')}`;
    },
    preciPlotlines() {
      if (this.daily) {
        return [
          {
            color: '#9E9E9E',
            value: 15,
            dashStyle: 'longdash',
            width: 1,
            zIndex: 4,
            label: {
              text: 'Sem alerta 0 a 15 mm',
              style: {
                color: '#9E9E9E',
              },
            },
          },
          {
            color: '#BED7DC',
            value: 40,
            dashStyle: 'longdash',
            width: 1,
            zIndex: 4,
            label: {
              text: 'Elevada 15 a 40 mm',

              style: {
                color: '#BED7DC',
                verticalAlign: '',
                textAlign: 'left',
              },
            },
          },
          {
            color: '#9BC3CD',
            value: 55,
            dashStyle: 'longdash',
            width: 1,
            zIndex: 4,
            label: {
              text: 'Moderada 40 a 55 mm',

              style: {
                color: '#9BC3CD',
                verticalAlign: '',
                textAlign: 'left',
              },
            },
          },
          {
            color: '#73A5B4',
            value: 105,
            dashStyle: 'longdash',
            width: 1,
            zIndex: 4,
            label: {
              text: 'Forte 55 a 105 mm',

              style: {
                color: '#73A5B4',
                verticalAlign: '',
                textAlign: 'left',
              },
            },
          },
          {
            color: '#4B879B',
            value: 155,
            dashStyle: 'longdash',
            width: 1,
            zIndex: 4,
            label: {
              text: 'Intensa 105 a 155 mm',

              style: {
                color: '#4B879B',
                verticalAlign: '',
                textAlign: 'left',
              },
            },
          },
          {
            color: '#286E82',
            value: 180,
            dashStyle: 'longdash',
            width: 1,
            zIndex: 4,
            label: {
              text: 'Extrema acima de 155 mm',

              style: {
                color: '#286E82',
                verticalAlign: '',
                textAlign: 'left',
              },
            },
          },
        ];
      }
      return [
        {
          color: '#9E9E9E',
          value: 15,
          dashStyle: 'longdash',
          width: 1,
          zIndex: 4,
          label: {
            text: 'Sem alerta 0 a 8,4 mm',
            style: {
              color: '#9E9E9E',
            },
          },
        },
        {
          color: '#9BC3CD',
          value: 55,
          dashStyle: 'longdash',
          width: 1,
          zIndex: 4,
          label: {
            text: 'Moderada 8,4 a 20 mm',

            style: {
              color: '#9BC3CD',
              verticalAlign: '',
              textAlign: 'left',
            },
          },
        },
        {
          color: '#73A5B4',
          value: 105,
          dashStyle: 'longdash',
          width: 1,
          zIndex: 4,
          label: {
            text: 'Forte 20 a 38 mm',

            style: {
              color: '#73A5B4',
              verticalAlign: '',
              textAlign: 'left',
            },
          },
        },
        {
          color: '#4B879B',
          value: 155,
          dashStyle: 'longdash',
          width: 1,
          zIndex: 4,
          label: {
            text: 'Intensa 38 a 55 mm',

            style: {
              color: '#4B879B',
              verticalAlign: '',
              textAlign: 'left',
            },
          },
        },
        {
          color: '#286E82',
          value: 155,
          dashStyle: 'longdash',
          width: 1,
          zIndex: 4,
          label: {
            text: 'Extrema acima de 55 mm',

            style: {
              color: '#286E82',
              verticalAlign: '',
              textAlign: 'left',
            },
          },
        },
      ];
    },
  },
  methods: {
    roundUpMaxValue(value) {
      if (value === 0) return 100;

      const margin = 0.20;
      const withMargin = value * (1 + margin);

      const orderOfMagnitude = Math.pow(10, Math.floor(Math.log10(value)));

      const units = Math.ceil(withMargin / orderOfMagnitude);

      return units * orderOfMagnitude;
    },
    getYAxisConfig(maxValue, titleText = 'Consumidores Interrompidos (CI)') {
      return {
        type: 'linear',
        min: 0,
        max: maxValue,
        endOnTick: true,
        maxPadding: 0,
        startOnTick: true,
        tickPositioner: function (min, max) {
          const positions = [];
          const tickInterval = (max - min) / 5;

          for (let i = min; i <= max; i += tickInterval) {
            positions.push(Math.round(i));
          }

          if (positions[positions.length - 1] < max) {
            positions.push(max);
          }

          return positions;
        },
        title: {
          text: titleText,
          style: {
            color: '#E8F4F9',
          },
        },
        labels: {
          style: {
            color: '#E8F4F9',
          },
        },
        gridLineDashStyle: 'longdash',
        gridLineColor: '#384150',
      };
    },
    backToPreviousScreen() {
      this.$router.go(-1);
    },
    isSelectedDaily(item) {
      return this.selectedDaily.some((el) => el.id === item.id);
    },
    toggleItemDaily(item) {
      if (this.selectedDaily.some((el) => el.id === item.id)) {
        if (this.selectedDaily.length > 1) {
          this.removeDaily(item);
        }
      } else {
        this.selectedDaily.push(item);
      }
      this.fetchCiChartsData();
    },
    removeDaily(item) {
      if (this.selectedDaily.some((el) => el.id == item.id)) {
        let index = this.selectedDaily.map((e) => e.id).indexOf(item.id);
        if (index > -1) {
          this.selectedDaily.splice(index, 1);
        }
      }
    },
    isSelectedhourlyInDailyPeriods(item) {
      return this.hourlyInDailyPeriodsSelected.id === item.id;
    },
    togglehourlyInDailyPeriods(item) {
      this.hourlyInDailyPeriodsSelected = item;
      this.fetchCiChartsData();
    },
    isSelectedHour(item) {
      return this.selectedHour.some((el) => el.id === item.id);
    },
    toggleItemHour(item) {
      if (this.selectedHour.some((el) => el.id === item.id)) {
        if (this.selectedHour.length > 1) {
          this.removeHour(item);
        }
      } else {
        this.selectedHour.push(item);
      }
      this.fetchCiChartsData();
    },
    removeHour(item) {
      if (this.selectedHour.some((el) => el.id == item.id)) {
        let index = this.selectedHour.map((e) => e.id).indexOf(item.id);
        if (index > -1) {
          this.selectedHour.splice(index, 1);
        }
      }
    },
    resizeCharts() {
      const root = document.getElementById('charts-container');
      const observer = new ResizeObserver(() => {
        this.ciChartRegional.reflow();
        this.ciChartFull.reflow();
        this.ciChartFullRegional.reflow();
        this.ciChartAgency.reflow();
        this.ciChartCountie.reflow();
        this.windChart.reflow();
        this.preciChart.reflow();
        this.tempChart.reflow();
        this.tempMedChart.reflow();
        this.lightningChart.reflow();
        this.weatherAlertChart.reflow();
        this.rerenderFakeLegend();
      });
      observer.observe(root);
    },
    createCiChartRegional() {
      const colors = ['#5AC76C', '#FFB656', '#76D4DE', '#EB6D40', '#F061FC'];
      const historicalRegionalData = this.historicalRegionalData;
      let series = [];
      const categoriesAll = [];

      let formattedSelectedDate = this.daily ?
       this.selectedDaily.map((dateItem) => dateItem.name.substring(5)) :
       this.selectedHour.map((dateItem) => dateItem.name);

      formattedSelectedDate = formattedSelectedDate.reverse();


      formattedSelectedDate.forEach((item) => {
        if (series.length < 5 && series.every((item) => item.dateToSort != item)) {
          series.push({
            name: `---`,
            data: [],
            runtime: '',
            dateToSort: item,
          })
        }
      });

      historicalRegionalData.forEach((e) => {
        e.agencyIds.forEach((agency) => {
          categoriesAll.push(agency);
        });
        const formattedRuntime = this.daily ?
        moment(e.runtime).utc().format('DD/MM/YYYY') :
        moment(e.runtime).format('DD/MM/YYYY HH:mm');

        for (let i = 0; i < series.length; i++) {
          if (series[i].dateToSort == formattedRuntime) {
            series[i].name =  `Previsto em ${formattedRuntime}`,
            series[i].runtime = formattedRuntime,
            series[i].data.push({
              y: e.sumCistart,
              labelTooltip: `em torno de `,
              labelValueTooltip: e.sumCistart.toLocaleString(),
            });
            return;
          }
        }
      });
      series.sort((a, b) => {
        return a.dateToSort < b.dateToSort ? -1 : a.dateToSort > b.dateToSort ? 1 : 0;
      });


      let categories = categoriesAll.filter(
        (este, i) => categoriesAll.indexOf(este) === i,
      );
      let maxValue = 0;
      series.forEach(serie => {
        if (serie.name !== 'Total de unidades consumidoras') {
          serie.data.forEach(point => {
            if (point.y > maxValue) {
              maxValue = point.y;
            }
          });
        }
      });

      if (maxValue === 0) maxValue = 100;

      maxValue = this.roundUpMaxValue(maxValue);

      this.ciChartRegional = Highcharts.chart('ciChartRegional', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,
          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-ci-chart',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-ci-chart',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
          text: '<i class="icon-alertadis-lightbulb-off-outline"></i><span> Previsão de Consumidor Interrompido nas Bases de Serviço de Campo</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: `Previsão de interrupções nas Bases de Serviço de Campo da regional  ${
            this.filterSelected.location.fullname
          } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          categories: categories,
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
        },
        yAxis: this.getYAxisConfig(maxValue),

        data: {
          decimalPoint: '.',
        },
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-ci-chart',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-ci-chart',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemStyle: {color: '#E8F4F9'},
          itemHiddenStyle: {color: '#384150'},
          symbolRadius: 0,
        },
        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          headerFormat: `
          <span style="font-family: 'Manrope'; font-style: normal; font-weight: 500;font-size: 16px; line-height: 20px; letter-spacing: 0.5px; color: #FFFFFF;">{point.key}</span><table>`,
          pointFormat:
            '<tr><td style="color:{series.color};padding:0"><div style="width: 12px; height: 12px; background-color:{series.color}"></div> </td>' +
            `<td style="padding-left: 1px; color: #E8F4F9">{series.name}: {point.labelTooltip} <b>{point.labelValueTooltip}</b> </td>`,
          /*  '<td style="padding-left: 1px; color: #E8F4F9"></td></tr>', */
          footerFormat: `</table><div style="padding-top: 4px; font-family: 'Manrope'; font-style: normal; font-weight: 400;font-size: 12px; line-height: 16px; letter-spacing: 0.4px; color: #FFFFFF;">Previsão para ${moment(
            this.filterSelected.date,
          ).format('DD/MM/YYYY')}</div>`,
          shared: true,
          useHTML: true,
        },

        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        colors: colors,
        series: series,
      });
    },
    createCiChartFull() {
      const colors = ['#5AC76C', '#FFB656', '#76D4DE', '#EB6D40', '#F061FC'];
      const series = [];
      const categoriesAll = [];

      let formattedSelectedDate = this.daily ?
       this.selectedDaily.map((dateItem) => dateItem.name.substring(5)) :
       this.selectedHour.map((dateItem) => dateItem.name);

      formattedSelectedDate = formattedSelectedDate.reverse();

      formattedSelectedDate.forEach((item) => {
        if (series.length < 5 && series.every((item) => item.dateToSort != item)) {
          series.push({
            name: `---`,
            data: [],
            runtime: '',
            dateToSort: item,
          })
        }
      });

      this.historicalFullData.forEach((e) => {
        e.agencyIds.forEach((agency) => {
          categoriesAll.push(agency);
        });
        const formattedRuntime = this.daily ?
        moment(e.runtime).utc().format('DD/MM/YYYY') :
        moment(e.runtime).format('DD/MM/YYYY HH:mm');

        for (let i = 0; i < series.length; i++) {
          if (series[i].dateToSort ==formattedRuntime) {
            series[i].name =  `Previsto em ${formattedRuntime}`,
            series[i].runtime = formattedRuntime,
            series[i].data.push({
              y: e.sumCistart,
              labelTooltip: `em torno de `,
              labelValueTooltip: e.sumCistart.toLocaleString(),
            });
            return;
          }
        }
      });
      series.sort((a, b) => {
        return a.dateToSort < b.dateToSort ? -1 : a.dateToSort > b.dateToSort ? 1 : 0;
      });
      let categories = categoriesAll.filter(
        (este, i) => categoriesAll.indexOf(este) === i,
      );

      let maxValueFull = 0;
      series.forEach(serie => {
        if (serie.name !== 'Total de unidades consumidoras') {
          serie.data.forEach(point => {
            if (point.y > maxValueFull) {
              maxValueFull = point.y;
            }
          });
        }
      });

      if (maxValueFull === 0) maxValueFull = 100;

      maxValueFull = this.roundUpMaxValue(maxValueFull);

      this.ciChartFull = Highcharts.chart('ciChartFull', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,
          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-ci-chart-1',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-ci-chart-1',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
text: '<i class="icon-alertadis-lightbulb-off-outline"></i><span> Previsão de Consumidor Interrompido nas Bases de Serviço de Campo</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: `Previsão de interrupções nas Bases de Serviço de Campo da regional  ${this.regionalLabel(
            this.filterSelected.location.regional,
          )} - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          categories: categories,
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
        },
        yAxis: this.getYAxisConfig(maxValueFull),
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-ci-chart-1',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-ci-chart-1',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemStyle: {color: '#E8F4F9'},
          itemHiddenStyle: {color: '#384150'},
          symbolRadius: 0,
        },
        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          decimalPoint: '.',
          headerFormat: `
          <span style="font-family: 'Manrope'; font-style: normal; font-weight: 500;font-size: 16px; line-height: 20px; letter-spacing: 0.5px; color: #FFFFFF;">{point.key}</span><table>`,
          pointFormat:
            '<tr><td style="color:{series.color};padding:0"><div style="width: 12px; height: 12px; background-color:{series.color}"></div> </td>' +
            `<td style="padding-left: 1px; color: #E8F4F9">{series.name}: {point.labelTooltip} <b>{point.labelValueTooltip}</b> </td>`,

          footerFormat: `</table><div style="padding-top: 4px; font-family: 'Manrope'; font-style: normal; font-weight: 400;font-size: 12px; line-height: 16px; letter-spacing: 0.4px; color: #FFFFFF;">Previsão para ${moment(
            this.filterSelected.date,
          ).format('DD/MM/YYYY')}</div>`,
          shared: true,
          useHTML: true,
        },
        colors: colors,
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },

        series: series,
      });
    },

    createCiChartFullRegional() {
      const colors = ['#5AC76C', '#FFB656', '#76D4DE', '#EB6D40', '#F061FC'];
      const series = [];
      const categoriesAll = [];

      let formattedSelectedDate = this.daily ?
       this.selectedDaily.map((dateItem) => dateItem.name.substring(5)) :
       this.selectedHour.map((dateItem) => dateItem.name);

      formattedSelectedDate = formattedSelectedDate.reverse();

      formattedSelectedDate.forEach((item) => {
        if (series.length < 5 && series.every((item) => item.dateToSort != item)) {
          series.push({
            name: `---`,
            data: [],
            runtime: '',
            dateToSort: item,
          })
        }
      });

      this.historicalFullRegional.forEach((e) => {
        categoriesAll.push(this.regionalLabel(e.regionalId));
        const formattedRuntime = this.daily ?
        moment(e.runtime).utc().format('DD/MM/YYYY') :
        moment(e.runtime).local().format('DD/MM/YYYY HH:mm');

        for (let i = 0; i < series.length; i++) {
          if (series[i].dateToSort == formattedRuntime) {
            series[i].name =  `Previsto em ${formattedRuntime}`,
            series[i].runtime = formattedRuntime,
            series[i].data.push({
              y: e.sumCistart,
              labelTooltip: `em torno de `,
              labelValueTooltip: e.sumCistart.toLocaleString(),
            });
            return;
          }
        }
      });

      series.sort((a, b) => {
        return a.dateToSort < b.dateToSort ? -1 : a.dateToSort > b.dateToSort ? 1 : 0;
      });

      let categories = categoriesAll.filter(
        (este, i) => categoriesAll.indexOf(este) === i,
      );

      const dataTotalDeUC = [];
      categories.forEach((regional) => {
        this.historicalRegionalQtdeUc.forEach((e) => {
          if (regional == e.regionalDescription) {
            dataTotalDeUC.push({
              y: e.qtdeuc,
              labelValueTooltip: e.qtdeuc.toLocaleString(),
            });
          }
        });
      });

      series.push({
        name: 'Total de unidades consumidoras',
        data: dataTotalDeUC,
        grouping: false,
        pointPadding: 0,
        borderColor: 'rgba(255, 182, 86, 1)',
        borderWidth: 1,
        dashStyle: 'dash',
        color: 'rgba(255, 182, 86, 0.24)',
        labelTooltip: 'Total de unidades consumidoras:',
      });

      let maxValueFullRegional = 0;
      series.forEach(serie => {
        if (serie.name !== 'Total de unidades consumidoras') {
          serie.data.forEach(point => {
            if (point.y > maxValueFullRegional) {
              maxValueFullRegional = point.y;
            }
          });
        }
      });

      if (maxValueFullRegional === 0) maxValueFullRegional = 100;

      maxValueFullRegional = this.roundUpMaxValue(maxValueFullRegional);

      this.ciChartFullRegional = Highcharts.chart('ciChartFullRegional', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,
          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-ci-chart-3',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-ci-chart-3',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
          text: '<i class="icon-alertadis-lightbulb-off-outline"></i><span> Previsão de Consumidor Interrompido nas regionais</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: `Previsão de interrupções nas regionais - ${moment(
            this.filterSelected.date,
          ).format('DD/MM/YYYY')}.`,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          categories: categories,
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
        },
        yAxis: this.getYAxisConfig(maxValueFullRegional),
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-ci-chart-3',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-ci-chart-3',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemStyle: {color: '#E8F4F9'},
          itemHiddenStyle: {color: '#384150'},
          symbolRadius: 0,
        },
        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          headerFormat: `
    <span style="font-family: 'Manrope'; font-style: normal; font-weight: 500;font-size: 16px; line-height: 20px; letter-spacing: 0.5px; color: #FFFFFF;">{point.key}</span><table>`,
          pointFormat:
            '<tr><td style="color:{series.color};padding:0"><div style="width: 12px; height: 12px; background-color:{series.color}"></div> </td>' +
            '<td style="padding-left: 4px; color: #E8F4F9">{series.name}: {point.labelTooltip} <b>{point.labelValueTooltip}</b></td>',
          footerFormat: `</table><div style="padding-top: 4px; font-family: 'Manrope'; font-style: normal; font-weight: 400;font-size: 12px; line-height: 16px; letter-spacing: 0.4px; color: #FFFFFF;">Previsão para ${moment(
            this.filterSelected.date,
          ).format('DD/MM/YYYY')}</div>`,
          shared: true,
          useHTML: true,
        },

        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        colors: colors,
        series: series,
      });
    },
    createCiChartAgency() {
      const series = [];
      const categoriesAll = [];


      let formattedSelectedDate = this.daily ?
       this.selectedDaily.map((dateItem) => dateItem.name.substring(5)) :
       this.selectedHour.map((dateItem) => dateItem.name);

      formattedSelectedDate = formattedSelectedDate.reverse();

      formattedSelectedDate.forEach((item) => {
        if (series.length < 5 && series.every((item) => item.dateToSort != item)) {
          series.push({
            name: `---`,
            data: [],
            runtime: '',
            dateToSort: item,
          })
        }
      });

      const dataTotalDeUCAll = [];
      this.historicalAgencyData.forEach((e) => {
        categoriesAll.push(e.locationName);

        dataTotalDeUCAll.push(e.qtdeuc);

        const formattedRuntime = this.daily ?
        moment(e.runtime).utc().format('DD/MM/YYYY') :
        moment(e.runtime).format('DD/MM/YYYY HH:mm');

        for (let i = 0; i < series.length; i++) {
          if (series[i].dateToSort == formattedRuntime) {
            series[i].name =  `Previsto em ${formattedRuntime}`,
            series[i].runtime = formattedRuntime,
            series[i].data.push({
              result: e.result,
              color: e.color,
              y: e.cistart,
              cistop: e.cistop,
              cistart: e.cistart,
              classstart: e.classstart,
              classstop: e.classstop,
              qtdeuc: e.qtdeuc,
              valueForTooltip: this.ciTooltipForCountiesChart(e),
            });
            return;
          }
        }
      });


      series.sort((a, b) => {
        return a.dateToSort < b.dateToSort ? -1 : a.dateToSort > b.dateToSort ? 1 : 0;
      });

      let categories = categoriesAll.filter(
        (este, i) => categoriesAll.indexOf(este) === i,
      );

      let dataTotalDeUC = dataTotalDeUCAll.filter(
        (este, i) => dataTotalDeUCAll.indexOf(este) === i,
      );

      series.push({
        name: 'Total de unidades consumidoras',
        data: dataTotalDeUC.map((el) => ({
          y: el,
          valueForTooltip: el,
        })),
        grouping: false,
        pointPadding: 0,
        borderColor: 'rgba(255, 182, 86, 1)',
        borderWidth: 1,
        dashStyle: 'dash',
        color: 'rgba(255, 182, 86, 0.24)',
      });

      let maxValueAgency = 0;
      series.forEach(serie => {
        if (serie.name !== 'Total de unidades consumidoras') {
          serie.data.forEach(point => {
            if (point.y > maxValueAgency) {
              maxValueAgency = point.y;
            }
          });
        }
      });

      if (maxValueAgency === 0) maxValueAgency = 100;

      maxValueAgency = this.roundUpMaxValue(maxValueAgency);

      this.ciChartAgency = Highcharts.chart('ciChartAgency', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,
          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-ci-chart-2',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-ci-chart-2',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
          text: '<i class="icon-alertadis-lightbulb-off-outline"></i><span> Previsão de Consumidor Interrompido nos municípios</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: `Previsão de interrupções nos municípios da Base de Serviço de Campo ${
            this.filterSelected.location.id
          } ${this.filterSelected.location.name} - ${moment(
            this.filterSelected.date,
          ).format('DD/MM/YYYY')}`,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          categories: categories,
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
        },
        yAxis: this.getYAxisConfig(maxValueAgency),
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-ci-chart-2',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-ci-chart-2',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemStyle: {color: '#E8F4F9', border: '1px'},
          itemHiddenStyle: {color: '#384150'},
          symbolRadius: 0,
          padding: 18,
        },
        /*  tooltip: {
          backgroundColor: "#384150",
          borderWidth: 0,
          borderRadius: 10,
          headerFormat: `
          <span style="font-family: 'Manrope'; font-style: normal; font-weight: 500;font-size: 16px; line-height: 20px; letter-spacing: 0.5px; color: #FFFFFF;">{point.key}</span><table>`,
          pointFormat:
            '<tr><td style="color:{point.color};padding:0"><div style="width: 12px; height: 12px; background-color:{point.color}"></div> </td>' +
            '<td style="padding-left: 4px; color: #E8F4F9">{series.name}: em torno de </td>' +
            '<td style="padding-left: 4px; color: #E8F4F9"><b>{point.y:.1f}</b></td></tr>',
          footerFormat: `</table><div style="padding-top: 4px; font-family: 'Manrope'; font-style: normal; font-weight: 400;font-size: 12px; line-height: 16px; letter-spacing: 0.4px; color: #FFFFFF;">Previsão para ${moment(
            this.filterSelected.date
          ).format("DD/MM/YYYY")}</div>`,
          shared: true,
          useHTML: true,
        }, */

        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          headerFormat: `
          <div style="font-family: 'Manrope'; font-style: normal; font-weight: 500;font-size: 10px; line-height: 12px; letter-spacing: 0.4px; color: #FFFFFF;">MUNICÍPIO</div>
          <div style="padding-top: 2px; font-family: 'Manrope'; font-style: normal; font-weight: 500;font-size: 16px; line-height: 20px; letter-spacing: 0.5px; color: #FFFFFF;">{point.key}</div>
          <table>
            `,
          pointFormat: `<div style="padding-top: 4px">
            <tr>
              <td style="color:{point.color};padding:0"><div style="width: 12px; height: 12px; background-color:{point.color}"></div> </td>
              <td style="padding-left: 4px; color: #E8F4F9">{series.name}:  <b>{point.valueForTooltip}</b> </td>

            </tr>
          </div>
          `,
          footerFormat: `</table><div style="padding-top: 6px; font-family: 'Manrope'; font-style: normal; font-weight: 400;font-size: 12px; line-height: 16px; letter-spacing: 0.4px; color: #FFFFFF;">Previsão para ${moment(
            this.filterSelected.date,
          ).format('DD/MM/YYYY')}.</div>`,
          shared: true,
          useHTML: true,
        },
        colors: [
          '#1b1f2d',
          '#1b1f2d',
          '#1b1f2d',
          '#1b1f2d',
          '#1b1f2d',
          'rgba(255, 182, 86, 0.24)',
        ],
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },

        series: series,
      });
      this.fakeLegendAgencyChart = this.ciChartAgency.renderer
        .text(
          `
      <div style="display: flex; align-items: center">
        <div style="width: 12px; height: 12px; background-color:#5dd2d8"></div><span style="margin-left: 4px">Baixo</span>
        <div style="margin-left: 8px; width: 12px; height: 12px; background-color:#2b9da3"></div><span style="margin-left: 4px">Médio</span>
        <div style="margin-left: 8px; width: 12px; height: 12px; background-color:#8765d4"></div><span style="margin-left: 4px">Alto</span>
      </div>
      `,
          0,
          70,
          true,
        )
        .add();
    },
    createCiChartCountie() {
      let chartData = [...this.historicalCountieData];



      chartData.map((el) => {
        if (el.locationId == this.filterSelected.location.cityId) {
          el.totalUc = this.filterSelected.location.ucQuantity;
          el.y = el.cistart;
          el.runtimeParsed = this.daily
            ? moment.utc(el.runtime).format('DD/MM/YYYY')
            : moment(el.runtime)
                .tz('America/Sao_Paulo')
                .format('DD/MM/YYYY [às] HH:00');
          el.valueForTooltip = this.ciTooltipForCountiesChart(el);
        }
      });
      this.ciChartCountie = Highcharts.chart('ciChartCountie', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,
          marginBottom: 60,
          ignoreHiddenSeries: false,
          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-ci-chart-4',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-ci-chart-4',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
          text: '<i class="icon-alertadis-lightbulb-off-outline"></i><span> Previsão de Consumidor Interrompido no município</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: `Previsão de interrupções em ${
            this.filterSelected.location.name
          } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          categories: this.daily
            ? chartData.map((el) =>
                moment.utc(el.runtime).format('[Previsto em] DD/MM/YYYY'),
              )
            : chartData.map((el) =>
                moment(el.runtime)
                  .tz('America/Sao_Paulo')
                  .format('[Previsto em] DD/MM/YYYY [às] HH:00'),
              ),
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
        },
        yAxis: {
          type: 'linear',
          title: {
            text: 'Consumidores Interrompidos (CI)',
            style: {
              color: '#E8F4F9',
            },
          },
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
          gridLineDashStyle: 'longdash',
          gridLineColor: '#384150',
        },
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-ci-chart-4',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-ci-chart-4',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
          itemStyle: {color: '#E8F4F9', border: '1px'},
          itemHiddenStyle: {color: '#384150'},
          symbolRadius: 0,
        },
        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          headerFormat: `
          <div style="font-family: 'Manrope'; font-style: normal; font-weight: 500;font-size: 10px; line-height: 12px; letter-spacing: 0.4px; color: #FFFFFF;">MUNICÍPIO</div>
          <div style="padding-top: 2px; font-family: 'Manrope'; font-style: normal; font-weight: 500;font-size: 16px; line-height: 20px; letter-spacing: 0.5px; color: #FFFFFF;">${this.filterSelected.location.name}</div>
          <table>
            `,
          pointFormat: `<div style="padding-top: 4px">
            <tr>
              <td style="color:{point.color};padding:0"><div style="width: 12px; height: 12px; background-color:{point.color}"></div> </td>
              <td style="padding-left: 4px; color: #E8F4F9">{series.name}:  {point.runtimeParsed} </td>
              <td style="padding-left: 4px; color: #E8F4F9"><b>{point.valueForTooltip}</b></td>
            </tr>
          </div>
          `,
          footerFormat: `</table><div style="padding-top: 6px; font-family: 'Manrope'; font-style: normal; font-weight: 400;font-size: 12px; line-height: 16px; letter-spacing: 0.4px; color: #FFFFFF;">Previsão para ${moment(
            this.filterSelected.date,
          ).format('DD/MM/YYYY')}.</div>`,
          shared: true,
          useHTML: true,
        },
        colors: ['rgba(255, 182, 86, 0.24)'],
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: 'Total de unidades consumidoras',
            data: chartData.map((el) => ({
              y: el.totalUc,
              valueForTooltip: el.totalUc,
            })),
            grouping: false,
            pointPadding: 0,
            borderColor: 'rgba(255, 182, 86, 1)',
            borderWidth: 1,
            dashStyle: 'dash',
            pointWidth: 80,
          },
          {
            name: 'Previsto em',
            data: chartData,
            pointWidth: 60,
          },
        ],
      });
      this.fakeLegendCountieChart = this.ciChartCountie.renderer
        .text(
          `
      <div style="display: flex; align-items: center">
        <div style="width: 12px; height: 12px; background-color:#5dd2d8"></div><span style="margin-left: 4px">Baixo</span>
        <div style="margin-left: 8px; width: 12px; height: 12px; background-color:#2b9da3"></div><span style="margin-left: 4px">Médio</span>
        <div style="margin-left: 8px; width: 12px; height: 12px; background-color:#8765d4"></div><span style="margin-left: 4px">Alto</span>
      </div>
      `,
          0,
          70,
          true,
        )
        .add();
    },
    colorTooltipCiChart(result) {
      if (result == 'high') {
        return '#8765d4';
      }
      if (result == 'medium') {
        return '#2b9da3';
      }
      if (result == 'low') {
        return '#5dd2d8';
      }
      if (result == 'zero') {
        return '#9e9e9e';
      }
      if (result == undefined) {
        return '#9e9e9e';
      }
    },
    getWindColor(windSpeed) {
  if (windSpeed <= 40) {
    return '#9E9E9E';
  } else if (windSpeed <= 55) {
    return '#E6C000';
  } else if (windSpeed <= 70) {
    return '#DF9F3E';
  } else if (windSpeed <= 90) {
    return '#FF4444';
  } else {
    return '#873764';
  }
},
    getWindGradient(windSpeed) {
  if (windSpeed <= 40) {
    return {
      linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
      stops: [[0, '#EBEBEB'], [0.5, '#9E9E9E'], [1, '#4D4D4D']]
    };
  } else if (windSpeed <= 55) {
    return {
      linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
      stops: [[0, '#FFF5B0'], [0.5, '#FFE566'], [1, '#E6C000']]
    };
  } else if (windSpeed <= 70) {
    return {
      linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
      stops: [[0, '#FDB777'], [0.5, '#DF9F3E'], [1, '#FF6200']]
    };
  } else if (windSpeed <= 90) {
    return {
      linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
      stops: [[0, '#FF4444'], [0.5, '#C00000'], [1, '#3D0000']]
    };
  } else {
    return {
      linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
      stops: [[0, '#B4374B'], [0.5, '#873764'], [1, '#4A1040']]
    };
  }
},
    rerenderFakeLegend() {
      this.fakeLegendAgencyChart.attr({
        x: this.ciChartAgency.plotSizeX / 2,
        y:
          this.ciChartAgency.chartHeight -
          this.ciChartAgency.legend.legendHeight -
          10,
      });
      this.fakeLegendCountieChart.attr({
        x: this.ciChartCountie.plotSizeX / 2,
        y: this.ciChartCountie.chartHeight - 10,
      });
      this.fakeLegendWeatherAlertChart.attr({
        x: this.weatherAlertChart.plotSizeX / 2 - 90,
        y:
          this.weatherAlertChart.chartHeight -
          this.weatherAlertChart.legend.legendHeight -
          20,
      });

      this.fakeLegendLightningChartChart.attr({
        x: this.lightningChart.plotSizeX / 4 - 90,
        y:
          this.lightningChart.chartHeight -
          this.lightningChart.legend.legendHeight -
          33,
      });

      this.fakeLegendTempChartChart.attr({
        x: 52,
        y: 390,
      });

      this.fakeLegendPreciChartChart.attr({
        x: 33,
        y: 390,
      });

      this.fakeLegendWindChartChart.attr({
        x: 33,
        y: 390,
      });

      this.fakeLegendTempMedChartChart.attr({
        x: 33,
        y: 390,
      });
    },
    fetchCiChartsData() {
      if (this.filterSelected.periodId == 1) {
        const {type} = this.filterSelected;
        const filter = {...this.filterSelected};
        filter.runtimeHourMinute = this.hourlyInDailyPeriodsSelected.name;

        const runtimes = this.selectedDaily.map((el) => {
          let date = el.name.split(' ')[1];
          let hour = parseInt(filter.runtimeHourMinute.split(':')[0]);
          date = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
          let runtime = moment.utc(date).hour(hour).toISOString();
          return runtime;
        });
        filter.runtimes = runtimes;
        if (type == 'countie') {
          this.$store.dispatch('fetchDailyHistoricalCountieData', filter);
          this.$store.dispatch('fetchDailyHistoricalFullData', filter);
          this.$store.dispatch('fetchDailyHistoricalForecastsCouties', filter);
        }
        if (type == 'agency') {
          this.$store.dispatch('fetchDailyHistoricalAgencyData', filter);
          this.$store.dispatch('fetchDailyHistoricalFullData', filter);
          this.$store.dispatch('fetchDailyHistoricalForecastsAgencies', filter);
        }
        if (type == 'regional') {
          this.$store.dispatch('fetchDailyHistoricalRegionalData', filter);
          this.$store.dispatch('fetchDailyHistoricalFullRegionalData', filter);
          this.$store.dispatch(
            'fetchDailyHistoricalForecastsRegionals',
            filter,
          );
        }
      }
      if (this.filterSelected.periodId == 2) {
        const {type} = this.filterSelected;
        const filter = {...this.filterSelected};
        filter.typeSelected = 'graphic';
        const runtimes = this.selectedHour.map((el) => {
          let [date, hour] = el.name.split(' ');
          date = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
          hour = parseInt(hour.split(':')[0]);
          const toUtc = moment(date)
            .hour(hour)
            .utc()
            .format('YYYY-MM-DD[T]HH:mm:ss[Z]');
          return toUtc;
        });
        filter.runtimes = runtimes;
        if (type == 'countie') {
          this.$store.dispatch('fetchHourlyHistoricalCountieData', filter);
          this.$store.dispatch('fetchHourlyHistoricalFullData', filter);
          this.$store.dispatch('fetchHourlyHistoricalForecastsCouties', filter);
        }

        if (type == 'regional') {
          this.$store.dispatch('fetchHourlyHistoricalRegionalData', filter);
          this.$store.dispatch('fetchHourlyHistoricalFullRegionalData', filter);
          this.$store.dispatch(
            'fetchHourlyHistoricalForecastsRegionals',
            filter,
          );
        }
        if (type == 'agency') {
          this.$store.dispatch('fetchHourlyHistoricalAgencyData', filter);
          this.$store.dispatch('fetchHourlyHistoricalFullData', filter);
          this.$store.dispatch(
            'fetchHourlyHistoricalForecastsAgencies',
            filter,
          );
        }
      }
    },
    ciTooltipForCountiesChart(el) {
      if (el.result == 'high') {
        return `acima de ${el.cistart} (acima de ${el.classstart} %)`;
      }
      if (el.result == 'medium') {
        return `${el.cistart} a ${el.cistop} (${el.classstart} a ${el.classstop} %)`;
      }
      if (el.result == 'low') {
        return `${el.cistart} a ${el.cistop} (${el.classstart} a ${el.classstop} %)`;
      }
      if (el.result == 'zero') {
        return `${el.cistart} a ${el.cistop} (${el.classstart} a ${el.classstop} %)`;
      }
    },

    createWindChart() {
      const windPlotBands = this.recordedDataFromTelmetryStations[0]
        ? this.recordedDataFromTelmetryStations[0].windGust
        : null;
      const dataForecasts = [];
      const categories = [];
      const dataRecord = [];
      this.historicalForecastsData.forEach((el) => {
        categories.push(
          this.daily
            ? `Previsto em ${moment(el.runtime).utc().format('DD/MM/YYYY')}`
            : `Previsto em ${moment(el.runtime).format('DD/MM/YYYY HH:mm')}`,
        );

        if (el.windGust) {
          dataForecasts.push({
            y: el.windGust,
            labelForTooltip: this.daily
              ? `Previsto em ${moment(el.runtime).utc().format('DD/MM/YYYY')}`
              : `Previsto em ${moment(el.runtime).format('DD/MM/YYYY HH:mm')}`,
            solidColor: this.getWindColor(el.windGust),
            color: this.getWindGradient(el.windGust), 
          });
        }
        if (windPlotBands) {
          dataRecord.push({
            y: windPlotBands,
            labelForTooltip: this.daily
              ? `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                )
                  .utc()
                  .format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                ).format('DD/MM/YYYY HH:mm')}`,
            solidColor: 'rgba(224, 159, 62, 0.28)',
          });
        }
      });

      if (this.historicalForecastsData.length == 0) {
        if (windPlotBands) {
          categories.push(
            this.daily
              ? `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY HH:mm')}`,
          );
          dataRecord.push({
            y: windPlotBands,
            labelForTooltip: this.daily
              ? `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY HH:mm')}`,
            solidColor: 'rgba(224, 159, 62, 0.28)',
          });
        }
      }

      let text = '';

      if (this.filterSelected.type == 'agency') {
        text = this.daily
          ? `Dados previstos e registrados da rajada máxima de vento na agência ${
              this.filterSelected.location.fullname
                ? this.filterSelected.location.fullname
                : this.filterSelected.location.name
            } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`
          : `Dados previstos e registrados da rajada máxima de vento na agência ${
              this.filterSelected.location.fullname
                ? this.filterSelected.location.fullname
                : this.filterSelected.location.name
            } - ${moment(this.filterSelected.date).format(
              'DD/MM/YYYY HH:mm',
            )}.`;
      }

      if (this.filterSelected.type == 'countie') {
        text = `Dados previstos e registrados da rajada máxima de vento em ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;
      }

      if (this.filterSelected.type == 'regional') {
        text = `Dados previstos e registrados da rajada máxima de vento na regional ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;
      }

      this.windChart = Highcharts.chart('windChart', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,
          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-wind-chart-1',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-wind-chart-1',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
          text: '<i class="icon-alertadis-wind"></i><span> Rajada máxima de vento</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: text,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
          categories: categories,
        },
        yAxis: {
          title: {
            text: 'Rajada máxima de vento (km/h)',
            style: {
              color: '#E8F4F9',
            },
          },
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
          gridLineDashStyle: 'longdash',
          gridLineColor: '#384150',
          plotLines: [
            {
              value: 0,
              width: 1,
              dashStyle: 'longdash',
              zIndex: 4,
              label: {
                text: 'Fraco 0 a 40 Km/h',
                align: 'start',
                style: {
                  color: '#9E9E9E',
                 textOutline: '1px #151723', 
                },
              },
            },
            {
              color: '#E6C000',
              value: 40,
              dashStyle: 'longdash',
              width: 1,
              zIndex: 4,
              label: {
                text: ' Moderado 40 a 55 Km/h',
                style: {
                  color: '#E6C000',
                  textOutline: '1px #151723',
                },
              },
            },
            {
              color: '#DF9F3E',
              value: 55,
              dashStyle: 'longdash',
              width: 1,
              zIndex: 4,
              label: {
                text: 'Forte 55 a 70 km/h',

                style: {
                  color: '#DF9F3E',
                  verticalAlign: '',
                  textAlign: 'left',
                  textOutline: '1px #151723',
                },
              },
            },
            {
              color: '#B4374B',
              value: 70,
              dashStyle: 'longdash',
              width: 1,
              zIndex: 4,
              label: {
                text: 'Intenso 70 a 90 km/h',

                style: {
                  color: '#B4374B',
                  verticalAlign: '',
                  textAlign: 'left',
                  textOutline: '1px #151723',
                },
              },
            },
            {
              color: '#873764',
              value: 90,
              dashStyle: 'longdash',
              width: 1,
              zIndex: 4,
              label: {
                text: 'Extremo Acima de 90 km/h',

                style: {
                  color: '#873764',
                  verticalAlign: '',
                  textAlign: 'left',
                },
              },
            },
          ],
          plotBands: [
            {
              from: 0,
              to: windPlotBands,
              color: 'rgba(224, 159, 62, 0.28)',
            },
          ],
        },
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-wind-chart-1',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-wind-chart-1',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemHiddenStyle: {color: '#384150'},
          itemStyle: {color: '#E8F4F9', border: '1px'},
          symbolRadius: 0,
        },
        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          headerFormat: `
          <table>
            `,
          pointFormat: `<div style="padding-top: 6px; padding-bottom: 6px">
              <div style="display: flex">
                <div style="width: 12px; height: 12px; background:{point.solidColor}"></div>
                <div style="padding-left: 4px; color: #E8F4F9">{series.name}: <b> {point.y} km/h </b></div>
              </div>
              <div style="padding-top: 2px; color: #E8F4F9">{point.labelForTooltip} </div>
            </div>
          `,
          footerFormat: `</table>`,
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            borderWidth: 0,
          },
          area: {
            color: 'rgba(224, 159, 62, 0.28)',
            fillOpacity: 0,
            marker: false,
            lineWidth: 0,
            label: false,
            events: {
              legendItemClick: function () {
                let maxWindAxis = this.chart.yAxis[0];
                if (this.name === 'Registro da rajada máxima de vento') {
                  if (this.visible) {
                    maxWindAxis.update({
                      plotBands: [],
                    });
                  } else {
                    maxWindAxis.update({
                      plotBands: [
                        {
                          from: 0,
                          to: windPlotBands,
                          color: 'rgba(224, 159, 62, 0.28)',
                        },
                      ],
                    });
                  }
                }
              },
            },
          },
        },
        series: [
          {
            name: 'Registro da rajada máxima de vento',
            type: 'area',
            data: dataRecord,
          },
          {
            name: 'Previsão da rajada máxima de vento',
            type: 'column',
            data: dataForecasts,
            pointWidth: 20,
           color: {
    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
    stops: [
      [0, '#FDB777'],
      [0.5, '#DF9F3E'],
      [1, '#FF6200'],
    ],
  },
          },
        ],
      });
      if (dataRecord.length == 0 && dataForecasts.length == 0) {
        this.fakeLegendWindChartChart = this.windChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados previstos e registrados para o dia selecionado.
            </div>
      </div>
      `,
            33,
            400,
            true,
          )
          .add()
          .toFront();

        return;
      }
      if (dataForecasts.length == 0) {
        this.fakeLegendWindChartChart = this.windChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados previstos para o dia selecionado.
            </div>
      </div>
      `,
            33,
            550,
            true,
          )
          .add();

        return;
      }

      if (dataRecord.length == 0) {
        this.fakeLegendWindChartChart = this.windChart.renderer
          .text(
            `
<div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
<div class="d-flex">
    <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
      <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
       Não há dados registrados para o dia selecionado.
    </div>
</div>
`,
            33,
            390,
            true,
          )
          .add()
          .toFront();

        return;
      }

      this.fakeLegendWindChartChart = this.windChart.renderer.text('').add();
    },
    createPreciChart() {
      const preciDataPlotBands = this.recordedDataFromTelmetryStations[0]
        ? this.recordedDataFromTelmetryStations[0].maxPrec
          ? this.recordedDataFromTelmetryStations[0].maxPrec
          : this.recordedDataFromTelmetryStations[0].accumPrec
        : null;

      const dataForecasts = [];
      const categories = [];
      const dataRecord = [];
      this.historicalForecastsData.forEach((el) => {
        categories.push(
          this.daily
            ? `Previsto em ${moment(el.runtime).utc().format('DD/MM/YYYY')}`
            : `Previsto em ${moment(el.runtime).format('DD/MM/YYYY HH:mm')}`,
        );

        dataForecasts.push({
          y: el.precIntensity,
          labelForTooltip: this.daily
            ? `Previsto em ${moment(el.runtime).utc().format('DD/MM/YYYY')}`
            : `Previsto em ${moment(el.runtime).format('DD/MM/YYYY HH:mm')}`,
          solidColor: '#286E82',
        });
        if (preciDataPlotBands) {
          dataRecord.push({
            y: preciDataPlotBands,
            labelForTooltip: this.daily
              ? `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                )
                  .utc()
                  .format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                ).format('DD/MM/YYYY HH:mm')}`,
            solidColor: 'rgba(224, 159, 62, 0.28)',
          });
        }
      });

      if (this.historicalForecastsData.length == 0) {
        if (preciDataPlotBands) {
          categories.push(
            this.daily
              ? `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY HH:mm')}`,
          );

          dataRecord.push({
            y: preciDataPlotBands,
            labelForTooltip: this.daily
              ? `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY HH:mm')}`,
            solidColor: 'rgba(224, 159, 62, 0.28)',
          });
        }
      }

      let text = '';
      let nameSerie = '';
      if (this.filterSelected.type == 'agency') {
        text = `Dados previstos e registrados de precipitação na agência ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;

        nameSerie = 'Registro de maior precipitação acumulada';
      }

      if (this.filterSelected.type == 'countie') {
        text = `Dados previstos e registrados de precipitação em ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;

        nameSerie = 'Registro da precipitação acumulada';
      }
      if (this.filterSelected.type == 'regional') {
        text = `Dados previstos e registrados de precipitação na regional ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;

        nameSerie = 'Registro de maior precipitação acumulada';
      }

      this.preciChart = Highcharts.chart('preciChart', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,

          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-preci-chart-1',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-preci-chart-1',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
          text: '<i class="icon-alertadis-cloud-showers-alt"></i><span> Precipitação</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: text,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },

          categories: categories,
        },
        yAxis: {
          reversed: true,
          title: {
            text: 'Precipitação acumulada (mm)',
            style: {
              color: '#E8F4F9',
            },
          },
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
          gridLineDashStyle: 'longdash',
          gridLineColor: '#384150',
          plotLines: this.preciPlotlines,
          plotBands: [
            {
              from: 0,
              to: preciDataPlotBands,
              color: 'rgba(115, 165, 180, 0.28)',
            },
          ],
        },
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-preci-chart-1',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-preci-chart-1',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemHiddenStyle: {color: '#384150'},
          itemStyle: {color: '#E8F4F9', border: '1px'},
          symbolRadius: 0,
        },
        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          headerFormat: `
          <table>
            `,
          pointFormat: `<div style="padding-top: 6px; padding-bottom: 6px">
              <div style="display: flex">
                <div style="width: 12px; height: 12px; background:{point.solidColor}"></div>
                <div style="padding-left: 4px; color: #E8F4F9">{series.name}: <b> {point.y} mm </b></div>
              </div>
              <div style="padding-top: 2px; color: #E8F4F9">{point.labelForTooltip} </div>
            </div>
          `,
          footerFormat: `</table>`,
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            borderWidth: 0,
          },
          area: {
            color: 'rgba(115, 165, 180, 0.28)',
            fillOpacity: 0,
            marker: false,
            lineWidth: 0,
            label: false,
            events: {
              legendItemClick: function () {
                let maxPreciAxis = this.chart.yAxis[0];
                if (this.name === 'Registro da precipitação acumulada') {
                  if (this.visible) {
                    maxPreciAxis.update({
                      plotBands: [],
                    });
                  } else {
                    maxPreciAxis.update({
                      plotBands: [
                        {
                          from: 0,
                          plotBands: preciDataPlotBands,
                          color: 'rgba(115, 165, 180, 0.28)',
                        },
                      ],
                    });
                  }
                }
              },
            },
          },
        },
        series: [
          {
            name: nameSerie,
            type: 'area',
            data: dataRecord,
          },
          {
            name: 'Previsão da precipitação acumulada',
            type: 'column',
            data: dataForecasts,
            pointWidth: 20,
            color: {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1,
              },
              stops: [
                [0, '#BED7DC'],
                [0.3, '#9BC3CD'],
                [0.7, '#4B879B'],
                [1, '#286E82'],
              ],
            },
          },
        ],
      });

      if (preciDataPlotBands == null && dataForecasts.length == 0) {
        this.fakeLegendPreciChartChart = this.preciChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados previstos e registrados para o dia selecionado.
            </div>
      </div>
      `,
            33,
            400,
            true,
          )
          .add()
          .toFront();
        return;
      }
      if (dataForecasts.length == 0) {
        this.fakeLegendPreciChartChart = this.preciChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados previstos para o dia selecionado.
            </div>
      </div>
      `,
            33,
            550,
            true,
          )
          .add();

        return;
      }

      if (preciDataPlotBands == null) {
        this.fakeLegendPreciChartChart = this.preciChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados registrados para o dia selecionado.
            </div>
      </div>
      `,
            33,
            390,
            true,
          )
          .add()
          .toFront();

        return;
      }

      this.fakeLegendPreciChartChart = this.preciChart.renderer.text('').add();
    },
    createTempChart() {
      const maxTemp = this.recordedDataFromTelmetryStations[0]
        ? this.recordedDataFromTelmetryStations[0].maxTemp
        : null;
      const minTemp = this.recordedDataFromTelmetryStations[0]
        ? this.recordedDataFromTelmetryStations[0].minTemp
        : null;

      const dataForecasts = [];
      const categories = [];
      const dataRecordTempMax = [];
      const dataRecordTempMin = [];
      this.historicalForecastsData.forEach((el) => {
        categories.push(
          this.daily
            ? `Previsto em ${moment(el.runtime).utc().format('DD/MM/YYYY')}`
            : `Previsto em ${moment(el.runtime).format('DD/MM/YYYY HH:mm')}`,
        );

        if (el.tempMax && el.tempMin) {
          dataForecasts.push({
            y: el.tempMax,
            labelForTooltip: this.daily
              ? `Previsto em ${moment(el.runtime).utc().format('DD/MM/YYYY')}`
              : `Previsto em ${moment(el.runtime).format('DD/MM/YYYY HH:mm')}`,
            solidColor: '#B95A19',
            low: el.tempMin,
            labelValueTooltip: `${el.tempMin} ºC a ${el.tempMax} ºC`,
          });
        }
        if (maxTemp) {
          dataRecordTempMax.push({
            y: maxTemp,
            labelForTooltip: this.daily
              ? `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                )
                  .utc()
                  .format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                ).format('DD/MM/YYYY HH:mm')}`,
            solidColor: 'rgba(215, 160, 55, 0.28)',
            labelValueTooltip: `${maxTemp} ºC`,
          });
        }
        if (minTemp) {
          dataRecordTempMin.push({
            y: minTemp,
            labelForTooltip: this.daily
              ? `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                )
                  .utc()
                  .format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                ).format('DD/MM/YYYY HH:mm')}`,
            solidColor: 'rgba(105, 190, 205, 0.28)',
            labelValueTooltip: `${minTemp} ºC`,
          });
        }
      });

      if (this.historicalForecastsData.length == 0) {
        if (maxTemp > 0 || minTemp > 0) {
          categories.push(
            this.daily
              ? `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY HH:mm')}`,
          );
        }
        if (maxTemp) {
          dataRecordTempMax.push({
            y: maxTemp,
            labelForTooltip: this.daily
              ? `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY HH:mm')}`,
            solidColor: 'rgba(215, 160, 55, 0.28)',
            labelValueTooltip: `${maxTemp} ºC`,
          });
        }
        if (minTemp) {
          dataRecordTempMin.push({
            y: minTemp,
            labelForTooltip: this.daily
              ? `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.recordedDataFromTelmetryStations[0].datetime,
                ).format('DD/MM/YYYY HH:mm')}`,
            solidColor: 'rgba(105, 190, 205, 0.28)',
            labelValueTooltip: `${minTemp} ºC`,
          });
        }
      }

      let text = '';

      if (this.filterSelected.type == 'agency') {
        text = `Dados previstos e registrados de temperatura na agência ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;
      }

      if (this.filterSelected.type == 'countie') {
        text = `Dados previstos e registrados de temperatura em ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;
      }
      if (this.filterSelected.type == 'regional') {
        text = `Dados previstos e registrados de temperatura na regional ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;
      }

      this.tempChart = Highcharts.chart('tempChart', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,

          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-temp-chart-1',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-temp-chart-1',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
          text: '<i class="icon-alertadis-temperature-three-quarter"></i><span> Temperatura</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: text,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
          categories: categories,
        },
        yAxis: {
          min: 10,
          alignTicks: false,
          tickInterval: 5,
          title: {
            text: 'Temperatura (ºC)',
            style: {
              color: '#E8F4F9',
            },
          },
          labels: {
            style: {
              color: '#E8F4F9',
            },
            formatter: function () {
              return this.value + '°C';
            },
          },
          gridLineDashStyle: 'longdash',
          gridLineColor: '#384150',
          plotBands: [
            {
              from: minTemp,
              to: maxTemp,
              color: 'rgba(215, 160, 55, 0.28)',
            },
            {
              from: 0,
              to: minTemp,
              color: 'rgba(105, 190, 205, 0.28)',
            },
          ],
        },
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-temp-chart-1',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-temp-chart-1',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemHiddenStyle: {color: '#384150'},
          itemStyle: {color: '#E8F4F9', border: '1px'},
          symbolRadius: 0,
        },
        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          headerFormat: `
          <table>
            `,
          pointFormat: `<div style="padding-top: 6px; padding-bottom: 6px">
              <div style="display: flex">
                <div style="width: 12px; height: 12px; background:{point.solidColor}"></div>
                <div style="padding-left: 4px; color: #E8F4F9">{series.name}: <b>{point.labelValueTooltip}</b></div>
              </div>
              <div style="padding-top: 2px; color: #E8F4F9">{point.labelForTooltip} </div>
            </div>
          `,
          footerFormat: `</table>`,
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          bullet: {
            borderWidth: 0,
          },
          area: {
            color: 'rgba(115, 165, 180, 0.28)',
            fillOpacity: 0,
            marker: false,
            lineWidth: 0,
            label: false,
            events: {
              legendItemClick: function () {
                let yAxisToUpdate = this.chart.yAxis[0];
                let tempMaxVisible = this.chart.legend.allItems[0].visible;
                let tempMinVisible = this.chart.legend.allItems[1].visible;
                if (this.name === 'Registro da temperatura máxima') {
                  if (tempMaxVisible && tempMinVisible) {
                    yAxisToUpdate.update({
                      plotBands: [
                        {
                          from: 0,
                          to: 16,
                          color: 'rgba(105, 190, 205, 0.28)',
                        },
                      ],
                    });
                  }
                  if (tempMaxVisible && !tempMinVisible) {
                    yAxisToUpdate.update({
                      plotBands: [],
                    });
                  }
                  if (!tempMaxVisible && tempMinVisible) {
                    yAxisToUpdate.update({
                      plotBands: [
                        {
                          from: 16,
                          to: 28,
                          color: 'rgba(215, 160, 55, 0.28)',
                        },
                        {
                          from: 0,
                          to: 16,
                          color: 'rgba(105, 190, 205, 0.28)',
                        },
                      ],
                    });
                  }
                  if (!tempMaxVisible && !tempMinVisible) {
                    yAxisToUpdate.update({
                      plotBands: [
                        {
                          from: 16,
                          to: 28,
                          color: 'rgba(215, 160, 55, 0.28)',
                        },
                      ],
                    });
                  }
                }
                if (this.name === 'Registro da temperatura mínima') {
                  if (tempMaxVisible && tempMinVisible) {
                    yAxisToUpdate.update({
                      plotBands: [
                        {
                          from: 16,
                          to: 28,
                          color: 'rgba(215, 160, 55, 0.28)',
                        },
                      ],
                    });
                  }
                  if (!tempMaxVisible && tempMinVisible) {
                    yAxisToUpdate.update({
                      plotBands: [],
                    });
                  }
                  if (tempMaxVisible && !tempMinVisible) {
                    yAxisToUpdate.update({
                      plotBands: [
                        {
                          from: 16,
                          to: 28,
                          color: 'rgba(215, 160, 55, 0.28)',
                        },
                        {
                          from: 0,
                          to: 16,
                          color: 'rgba(105, 190, 205, 0.28)',
                        },
                      ],
                    });
                  }
                  if (!tempMaxVisible && !tempMinVisible) {
                    yAxisToUpdate.update({
                      plotBands: [
                        {
                          from: 0,
                          to: 16,
                          color: 'rgba(105, 190, 205, 0.28)',
                        },
                      ],
                    });
                  }
                }
              },
            },
          },
        },
        series: [
          {
            name: 'Registro da temperatura máxima',
            type: 'area',
            color: 'rgba(215, 160, 55, 0.28)',
            data: dataRecordTempMax,
          },
          {
            name: 'Registro da temperatura mínima',
            type: 'area',
            color: 'rgba(105, 190, 205, 0.28)',
            data: dataRecordTempMin,
          },
          {
            type: 'bullet',
            name: 'Previsão da temperatura',
            data: dataForecasts,
            pointWidth: 20,
            color: {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1,
              },
              stops: [
                [0, '#B95A19'],
                [0.3, '#BED26E'],
                [0.7, '#69BECD'],
                [1, '#145582'],
              ],
            },
          },
        ],
      });
      if (
        dataRecordTempMax.length == 0 &&
        dataRecordTempMin.length == 0 &&
        dataForecasts.length == 0
      ) {
        this.fakeLegendTempChartChart = this.tempChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados previstos e registrados para o dia selecionado.
            </div>
      </div>
      `,
            52,
            400,
            true,
          )
          .add()
          .toFront();

        return;
      }

      if (dataForecasts.length == 0) {
        this.fakeLegendTempChartChart = this.tempChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados previstos para o dia selecionado.
            </div>
      </div>
      `,
            52,
            550,
            true,
          )
          .add()
          .toFront();

        return;
      }

      if (dataRecordTempMax.length == 0 && dataRecordTempMin.length == 0) {
        this.fakeLegendTempChartChart = this.tempChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados registrados para o dia selecionado.
            </div>
      </div>
      `,
            52,
            390,
            true,
          )
          .add()
          .toFront();

        return;
      }

      this.fakeLegendTempChartChart = this.tempChart.renderer.text('').add();
    },
 createLightningChart(data) {
  const regionalLabel = (regional) => {
    if (regional == 88 || regional == 'DOCCMN') {
      return 'DOCCMN';
    }
    if (regional == 89 || regional == 'DOCCSL') {
      return 'DOCCSL';
    }
    if (regional == 90 || regional == 'DOCMSL') {
      return 'DOCMSL';
    }
    if (regional == 91 || regional == 'DOCNRO') {
      return 'DOCNRO';
    }
    if (regional == 92 || regional == 'DOCNRT') {
      return 'DOCNRT';
    }
    if (regional == 93 || regional == 'DOCOST') {
      return 'DOCOST';
    }
    if (regional == 94 || regional == 'DOCSUD') {
      return 'DOCSUD';
    }
  };

  const categories = [];
  const dataForecasts = [];
  
  if (data.type == 'regional') {
    const datetime =
      this.filterSelected.hour == ''
        ? moment(this.filterSelected.date).format('DD/MM/YYYY')
        : moment(this.filterSelected.date)
            .hour(this.filterSelected.hour)
            .format('DD/MM/YYYY [às] HH:mm');

    this.textSubtitle = `Dados registrados de raios nas regionais - ${datetime}`;
    this.textTitleTooltip = 'REGIONAL';
  }

  if (data.type == 'agency') {
    const datetime =
      this.filterSelected.hour == ''
        ? moment(this.filterSelected.date).format('DD/MM/YYYY')
        : moment(this.filterSelected.date)
            .hour(this.filterSelected.hour)
            .format('DD/MM/YYYY [às] HH:mm');
    this.textTitleTooltip = 'Base de Serviço de Campo';

    this.textSubtitle = `Dados registrados de raios nas agências da regional ${regionalLabel(
      this.filterSelected.location.regional,
    )} - ${datetime}`;
  }

  if (data.type == 'city') {
    const datetime =
      this.filterSelected.hour == ''
        ? moment(this.filterSelected.date).format('DD/MM/YYYY')
        : moment(this.filterSelected.date)
            .hour(this.filterSelected.hour)
            .format('DD/MM/YYYY [às] HH:mm');
    this.textTitleTooltip = 'MUNICÍPIO';
    this.textSubtitle = `Dados registrados de raios nos municípios da agência ${this.filterSelected.location.agencies[0]} -  ${datetime}`;
  }

  if (Array.isArray(data)) {
    data.forEach((item) => {
      categories.push(item.name);
      dataForecasts.push({
        y: item.y,
        labelForTooltip: `Registrado em ${moment(this.filterSelected.date).format('DD/MM/YYYY')}`,
        name: item.name
      });
    });
  }

  this.lightningChart = Highcharts.chart('lightningChart', {
    chart: {
      type: 'column',
      backgroundColor: '#151723',
      borderRadius: 16,
      marginTop: 80,
      events: {
        load: function () {
          const menuBtn = document.getElementsByClassName(
            'button-menu-lightning-chart-1',
          );
          const fullscreenBtn = document.getElementsByClassName(
            'button-fullscreen-lightning-chart-1',
          );
          menuBtn[0].children[2].setAttribute(
            'd',
            'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
          );
          menuBtn[0].children[2].setAttribute('fill', '#F5821E');
          menuBtn[0].children[2].setAttribute('stroke-width', 0);
          fullscreenBtn[0].children[2].setAttribute(
            'd',
            'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
          );
          fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
          fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
        },
      },
    },
    title: {
      useHTML: true,
      text: '<i class="icon-alertadis-bolt"></i><span> Raios</span>',
      align: 'left',
      style: {
        fontFamily: 'Manrope',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '18px',
        letterSpacing: '0.1px',
        color: '#E8F4F9',
      },
    },
    subtitle: {
      useHTML: false,
      text: this.textSubtitle,
      align: 'left',
      style: {
        fontFamily: 'Manrope',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.4px',
        color: '#E8F4F9',
      },
    },
    xAxis: {
      categories: categories,
      crosshair: true,
      labels: {
        style: {
          color: '#E8F4F9',
        },
      },
    },
    yAxis: {
      title: {
        text: 'Quantidade de raios',
        style: {
          color: '#E8F4F9',
        },
      },
      labels: {
        style: {
          color: '#E8F4F9',
        },
      },
      gridLineDashStyle: 'longdash',
      gridLineColor: '#384150',
    },
    exporting: {
      allowHTML: true,
      enabled: true,
      buttons: {
        contextButton: {
          className: 'button-menu-lightning-chart-1',
          theme: {
            fill: '#191C29',
            states: {
              hover: {
                fill: '#384150',
              },
              select: {
                fill: '#384150',
              },
            },
          },
          symbol: 'circle',
          menuItems: [
            {
              text: 'Imprimir gráfico',
              onclick() {
                this.print();
              },
            },
            {
              text: 'Baixar imagem PNG',
              onclick() {
                this.exportChartLocal({
                  type: 'image/png',
                });
              },
            },
            {
              text: 'Baixar imagem JPEG',
              onclick() {
                this.exportChartLocal({
                  type: 'image/jpeg',
                });
              },
            },
            {
              text: 'Baixar imagem SVG',
              async onclick() {
                this.exportChartLocal({
                  type: 'image/svg+xml',
                });
              },
            },
            {
              text: 'Baixar documento PDF',
              onclick() {
                this.exportChartLocal({
                  type: 'application/pdf',
                });
              },
            },
            {
              text: 'Baixar documento CSV',
              onclick() {
                this.downloadCSV();
              },
            },
            {
              text: 'Baixar documento XLS',
              onclick() {
                this.downloadXLS();
              },
            },
          ],
        },
        fullscreenButton: {
          className: 'button-fullscreen-lightning-chart-1',
          symbol: 'circle',
          onclick: function () {
            if (this.fullscreen.isOpen) {
              this.fullscreen.close();
            } else {
              this.fullscreen.open();
            }
          },
          theme: {
            fill: '#191C29',
            states: {
              hover: {
                fill: '#384150',
              },
              select: {
                fill: '#384150',
              },
            },
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
      itemHiddenStyle: {color: '#384150'},
      itemStyle: {color: '#E8F4F9', border: '1px'},
      symbolRadius: 0,
    },
    tooltip: {
      backgroundColor: '#384150',
      borderWidth: 0,
      borderRadius: 10,
      zIndex: 9999,
      headerFormat: `
      <div style="font-family: 'Manrope'; font-style: normal; font-weight: 500; font-size: 10px; line-height: 12px; letter-spacing: 0.4px; color: #FFFFFF;">${this.textTitleTooltip}</div>
      <table>
        `,
     pointFormat: `
<div style="padding-bottom: 6px; font-family: 'Manrope'; font-style: normal; font-weight: 500; font-size: 16px; line-height: 20px; letter-spacing: 0.5px; color: #FFFFFF;"> <b>{point.name}</b></div>
    <div style="display: flex; align-items: center">
      <div style="width: 12px; height: 12px; background: linear-gradient(180deg, #FFF3B0 0%, #e4d354 30%, #4B879B 70%, #286E82 100%);"></div>
      <div style="padding-left: 4px; color: #E8F4F9">Quantidade de raios: <b>{point.y}</b></div>
    </div>
`,
      footerFormat: `</table>
      <div style="padding-top: 6px; font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 12px; line-height: 16px; letter-spacing: 0.4px; color: #FFFFFF;">Registrado em ${moment(
        this.filterSelected.date,
      ).format('DD/MM/YYYY')}</div>
      `,
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        borderWidth: 0,
      },
    },
    series: [
      {
        name: 'Registro de raios',
        type: 'column',
        data: dataForecasts,
        pointWidth: 20,
        color: {
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1,
          },
          stops: [
                [0, '#FFF3B0'],     
                [0.3, '#e4d354'], 
                [0.7, '#4B879B'],
                [1, '#286E82'],

          ],
        },
      },
    ],
  });

  this.fakeLegendLightningChartChart =
    dataForecasts.length != 0
      ? this.lightningChart.renderer.text('').add()
      : this.lightningChart.renderer
          .text(
            `
  <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
    <div class="d-flex">
        <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
          <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
           Não houve ocorrência de raios.
        </div>
  </div>
  `,
            33,
            390,
            true,
          )
          .add();
},
    createWeatherAlertChart(data) {
      let categoriesAll = [];

      data.forEach((alerts) => {
        alerts.data.forEach((el) => {
          categoriesAll.push(el.name);
        });
      });
      let categories = categoriesAll.filter(
        (este, i) => categoriesAll.indexOf(este) === i,
      );
      categories.sort();
      this.weatherAlertChart = Highcharts.chart('weatherAlertChart', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,
          marginBottom: 90,
          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-weather-chart-1',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-weather-chart-1',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
          text: '<i class="icon-alertadis-thunderstorm-sun"></i><span> Alertas Meteorológicos</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: `Alertas previstos na regional ${
            this.filterSelected.location.fullname
          } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          type: 'category',
          categories: categories,
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
        },
        yAxis: {
          title: {
            text: 'Área em alerta (%)',
            style: {
              color: '#E8F4F9',
            },
          },
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
          gridLineDashStyle: 'longdash',
          gridLineColor: '#384150',
        },
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-weather-chart-1',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-weather-chart-1',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemHiddenStyle: {color: '#384150'},
          itemStyle: {color: '#E8F4F9', border: '1px'},
          symbolRadius: 0,
        },
        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          headerFormat: `
          <div style="font-family: 'Manrope'; font-style: normal; font-weight: 500; font-size: 10px; line-height: 12px; letter-spacing: 0.4px; color: #FFFFFF;">REGIONAL</div>
          <div style="padding-bottom: 6px; font-family: 'Manrope'; font-style: normal; font-weight: 500; font-size: 16px; line-height: 20px; letter-spacing: 0.5px; color: #FFFFFF;">${
            this.filterSelected.location.fullname
              ? this.filterSelected.location.fullname.toUpperCase()
              : null
          }</div>
          <table>
            `,
          pointFormat: `
              <div style="display: flex; align-items: center">
                <div style="width: 12px; height: 12px; background:{series.color}"></div>
                <div style="padding-left: 4px; color: #E8F4F9">Intensidade: <b>{point.label} {point.intensityLabel}</b> em <b>{point.y}% da regional</b> - Vigência <b>{point.validityLabel}</b></div>
              </div>
          `,
          footerFormat: `</table>
          <div style="padding-top: 6px; font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 12px; line-height: 16px; letter-spacing: 0.4px; color: #FFFFFF;">Enviado em ${moment(
            this.filterSelected.date,
          ).format('DD/MM/YYYY')} às {point.key}</div>
          `,
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            borderWidth: 1,
            pointPadding: 0.25,
            pointWidth: 10,
            dataLabels: {
              enabled: true,
              color: '#E8F4F9',
              formatter: function () {
                return '' + this.point.label;
              },
              style: {
                'font-family': 'Manrope',
                'font-weight': '400',
                'font-size': '12px',
              },
            },
          },
        },
        series: data,
      });
      this.fakeLegendWeatherAlertChart = this.weatherAlertChart.renderer
        .text(
          `
      <div style="display: flex; align-items: center">
        <div style="width: 12px; height: 12px; background:repeating-linear-gradient(
          45deg,
          #E1E1EB,
          #E1E1EB 3px,
          #757575 3px,
          #757575 6px); ">
        </div><span style="margin-left: 4px">Vigência: 1 hora</span>
        <div style="margin-left: 8px; width: 12px; height: 12px; background:repeating-linear-gradient(
          to right,
          #E1E1EB,
          #E1E1EB 3px,
          #757575 3px,
          #757575 6px);">
        </div><span style="margin-left: 4px">Vigência: 3 horas</span>
      </div>
      `,
          0,
          70,
          true,
        )
        .add();
    },

    createTempMedChart() {
      const medTemp = this.recordedDataFromTelmetryStations[0]
        ? this.recordedDataFromTelmetryStations[0].meanTemp
        : 0;

      const dataRecordTempMed = [];
      const categories = [];
      const dataForecasts = [];

      this.historicalForecastsData.forEach((el) => {
        categories.push(
          this.daily
            ? `Previsto em ${moment(el.runtime).utc().format('DD/MM/YYYY')}`
            : `Previsto em ${moment(el.runtime).format('DD/MM/YYYY HH:mm')}`,
        );

        if (el.temp) {
          dataForecasts.push({
            y: el.temp,
            labelForTooltip: this.daily
              ? `Previsto em ${moment(el.runtime).utc().format('DD/MM/YYYY')}`
              : `Previsto em ${moment(el.runtime).format('DD/MM/YYYY HH:mm')}`,
            solidColor: '#B95A19',
            labelValueTooltip: `${el.temp}ºC`,
          });
        }

        if (medTemp) {
          dataRecordTempMed.push({
            y: medTemp,
            labelForTooltip: this.daily
              ? `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                )
                  .utc()
                  .format('DD/MM/YYYY')}`
              : `Registrado em ${moment(
                  this.historicalForecastsData[
                    this.historicalForecastsData.length - 1
                  ].runtime,
                ).format('DD/MM/YYYY HH:mm')}`,
            solidColor: 'rgba(190, 210, 110, 0.28);',
            labelValueTooltip: `${medTemp} ºC`,
          });
        }
      });

      let text = '';

      if (this.filterSelected.type == 'agency') {
        text = `Dados previstos e registrados de temperatura na agência ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;
      }

      if (this.filterSelected.type == 'countie') {
        text = `Dados previstos e registrados de temperatura em ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;
      }
      if (this.filterSelected.type == 'regional') {
        text = `Dados previstos e registrados de temperatura na regional ${
          this.filterSelected.location.fullname
            ? this.filterSelected.location.fullname
            : this.filterSelected.location.name
        } - ${moment(this.filterSelected.date).format('DD/MM/YYYY')}.`;
      }

      this.tempMedChart = Highcharts.chart('tempMedChart', {
        chart: {
          type: 'column',
          backgroundColor: '#151723',
          borderRadius: 16,
          marginTop: 80,

          events: {
            load: function () {
              const menuBtn = document.getElementsByClassName(
                'button-menu-tempMed-chart-1',
              );
              const fullscreenBtn = document.getElementsByClassName(
                'button-fullscreen-tempMed-chart-1',
              );
              menuBtn[0].children[2].setAttribute(
                'd',
                'M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z',
              );
              menuBtn[0].children[2].setAttribute('fill', '#F5821E');
              menuBtn[0].children[2].setAttribute('stroke-width', 0);
              fullscreenBtn[0].children[2].setAttribute(
                'd',
                'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z',
              );
              fullscreenBtn[0].children[2].setAttribute('fill', '#F5821E');
              fullscreenBtn[0].children[2].setAttribute('stroke-width', 0);
            },
          },
        },
        title: {
          useHTML: true,
          text: '<i class="icon-alertadis-temperature-three-quarter"></i><span> Temperatura</span>',
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0.1px',
            color: '#E8F4F9',
          },
        },
        subtitle: {
          useHTML: false,
          text: text,
          align: 'left',
          style: {
            fontFamily: 'Manrope',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px',
            color: '#E8F4F9',
          },
        },
        xAxis: {
          crosshair: true,
          labels: {
            style: {
              color: '#E8F4F9',
            },
          },
          categories: categories,
        },
        yAxis: {
          min: 10,
          alignTicks: false,
          tickInterval: 5,
          title: {
            text: 'Temperatura (ºC)',
            style: {
              color: '#E8F4F9',
            },
          },
          labels: {
            style: {
              color: '#E8F4F9',
            },
            formatter: function () {
              return this.value + '°C';
            },
          },
          gridLineDashStyle: 'longdash',
          gridLineColor: '#384150',
          plotBands: [
            {
              from: 0,
              to: medTemp,
              color: 'rgba(190, 210, 110, 0.28)',
            },
          ],
        },
        exporting: {
          allowHTML: true,
          enabled: true,
          buttons: {
            contextButton: {
              className: 'button-menu-tempMed-chart-1',
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
              symbol: 'circle',
              menuItems: [
                {
                  text: 'Imprimir gráfico',
                  onclick() {
                    this.print();
                  },
                },
                {
                  text: 'Baixar imagem PNG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/png',
                    });
                  },
                },
                {
                  text: 'Baixar imagem JPEG',
                  onclick() {
                    this.exportChartLocal({
                      type: 'image/jpeg',
                    });
                  },
                },
                {
                  text: 'Baixar imagem SVG',
                  async onclick() {
                    this.exportChartLocal({
                      type: 'image/svg+xml',
                    });
                  },
                },
                {
                  text: 'Baixar documento PDF',
                  onclick() {
                    this.exportChartLocal({
                      type: 'application/pdf',
                    });
                  },
                },
                {
                  text: 'Baixar documento CSV',
                  onclick() {
                    this.downloadCSV();
                  },
                },
                {
                  text: 'Baixar documento XLS',
                  onclick() {
                    this.downloadXLS();
                  },
                },
              ],
            },
            fullscreenButton: {
              className: 'button-fullscreen-tempMed-chart-1',
              symbol: 'circle',
              onclick: function () {
                if (this.fullscreen.isOpen) {
                  this.fullscreen.close();
                } else {
                  this.fullscreen.open();
                }
              },
              theme: {
                fill: '#191C29',
                states: {
                  hover: {
                    fill: '#384150',
                  },
                  select: {
                    fill: '#384150',
                  },
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemHiddenStyle: {color: '#384150'},
          itemStyle: {color: '#E8F4F9', border: '1px'},
          symbolRadius: 0,
        },
        tooltip: {
          backgroundColor: '#384150',
          borderWidth: 0,
          borderRadius: 10,
          zIndex: 9999,
          headerFormat: `
          <table>
            `,
          pointFormat: `<div style="padding-top: 6px; padding-bottom: 6px">
              <div style="display: flex">
                <div style="width: 12px; height: 12px; background:{point.solidColor}"></div>
                <div style="padding-left: 4px; color: #E8F4F9">{series.name}: <b>{point.labelValueTooltip}</b></div>
              </div>
              <div style="padding-top: 2px; color: #E8F4F9">{point.labelForTooltip} </div>
            </div>
          `,
          footerFormat: `</table>`,
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          bullet: {
            borderWidth: 0,
          },
          area: {
            color: ' rgba(190, 210, 110, 0.28)',
            fillOpacity: 0,
            marker: false,
            lineWidth: 0,
            label: false,
          },
        },
        series: [
          {
            name: 'Registro da temperatura',
            type: 'area',
            color: 'rgba(190, 210, 110, 0.28)',
            data: dataRecordTempMed,
          },
          {
            type: 'bullet',
            name: 'Previsão da temperatura',
            data: dataForecasts,
            pointWidth: 20,
            color: {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1,
              },
              stops: [
                [0, '#B95A19'],
                [0.3, '#BED26E'],
                [0.7, '#69BECD'],
                [1, '#145582'],
              ],
            },
          },
        ],
      });

      if (dataRecordTempMed.length == 0 && dataForecasts.length == 0) {
        this.fakeLegendTempMedChartChart = this.tempMedChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados previstos e registrados para o dia selecionado.
            </div>
      </div>
      `,
            52,
            400,
            true,
          )
          .add()
          .toFront();

        return;
      }

      if (dataForecasts.length == 0) {
        this.fakeLegendTempMedChartChart = this.tempMedChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados previstos para o dia selecionado.
            </div>
      </div>
      `,
            52,
            550,
            true,
          )
          .add()
          .toFront();

        return;
      }

      if (dataRecordTempMed.length == 0) {
        this.fakeLegendTempMedChartChart = this.tempMedChart.renderer
          .text(
            `
      <div style="display: flex; align-items: center; flex-direction: row; padding: 4px;">
        <div class="d-flex">
            <div style="font-family: 'Manrope'; font-style: normal; font-weight: 400; font-size: 14px; color:#E65100">
              <i class="icon-alertadis-exclamation-triangle" style="color:#E65100; width: 16px; height: 16px;"></i>
               Não há dados registrados para o dia selecionado.
            </div>
      </div>
      `,
            52,
            390,
            true,
          )
          .add()
          .toFront();

        return;
      }

      this.fakeLegendTempMedChartChart = this.tempMedChart.renderer
        .text('')
        .add();
    },

    regionalLabel(regional) {
      if (regional == 88 || regional == 'DOCCMN') {
        return 'DOCCMN';
      }
      if (regional == 89 || regional == 'DOCCSL') {
        return 'DOCCSL';
      }
      if (regional == 90 || regional == 'DOCMSL') {
        return 'DOCMSL';
      }
      if (regional == 91 || regional == 'DOCNRO') {
        return 'DOCNRO';
      }
      if (regional == 92 || regional == 'DOCNRT') {
        return 'DOCNRT';
      }
      if (regional == 93 || regional == 'DOCOST') {
        return 'DOCOST';
      }
      if (regional == 94 || regional == 'DOCSUD') {
        return 'DOCSUD';
      }
    },

    toggleNavigation() {
      this.$emit('toggleNavigation');
    },
  },
};
</script>

<style scoped lang="scss">
.ci-forecast-title {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 33px;
  color: var(--v-primary-base);
}
.ci-forecast-sub-title {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.1px;
  color: var(--v-primary-base);
}

.daily-btn {
  margin-right: 4px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-accent-base);
  border: 1px solid var(--v-accent-base);
  border-radius: 8px;
  background-color: var(--v-secondary-base) !important;
  text-transform: none;
  .daily-btn-icon {
    color: #bac2cf;
  }
}

.daily-btn-active {
  background-color: var(--v-accent-base) !important;
  border: 1px solid var(--v-accent-base);
  .daily-btn-text {
    color: var(--v-primary-base);
  }
}

.hourly-in-daily-btn {
  width: 116px;
  margin-left: 4px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
  border: 1px solid var(--v-accent-base);
  border-radius: 4px;
  background-color: var(--v-secondary-base) !important;
  text-transform: none;
  .hourly-in-daily-btn-icon {
    color: #bac2cf;
  }
  .hourly-in-daily-btn-text {
    color: var(--v-accent-base);
  }
}
.hourly-in-daily-btn-active {
  background-color: var(--v-accent-base) !important;
  border: 1px solid var(--v-accent-base);
  .hourly-in-daily-btn-icon {
    color: var(--v-primary-base);
  }
  .hourly-in-daily-btn-text {
    color: var(--v-primary-base);
  }
}

.graph-table-chip {
  border-radius: 8px;
  background-color: var(--v-secondary-base);
  padding: 6px;
}
.forecast-time-text {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.chart-menu-text {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
  cursor: pointer;
}
::v-deep .highcharts-menu {
  background-color: var(--v-secondary-base) !important;
  box-shadow: none !important;
  border: none !important;
  border-radius: 8px !important;
}
::v-deep .highcharts-menu-item {
  color: var(--v-primary-base) !important;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
}
::v-deep .highcharts-menu-item:hover {
  background-color: var(--v-primary-darken3) !important;
}

.weather-alert-title {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.info-alert {
  padding: 5px;
  border-radius: 8px;
  color: var(--v-primary-darken3);
  background-color: var(--v-primary-base) !important;
}

.info-alert-text {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.btn-filter {
  text-transform: none;
  font-family: 'Manrope';
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
}
</style>
>
